import { z } from "zod";

export const Id = z.string().min(1).max(64);
export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD");
export const IsoDateTime = z.string().datetime({ offset: true });
export const Page = z.coerce.number().int().min(1).default(1);
export const PageSize = z.coerce.number().int().min(1).max(100).default(20);
export const Minor = z.number().int().min(0); // UAH kopecks

/** Trimmed text; "" → undefined so optional fields stay unset (the old `clean()` form helper). */
export const OptionalText = (max: number) =>
  z
    .string()
    .max(max)
    .transform((s) => s.trim())
    .transform((s) => (s === "" ? undefined : s))
    .optional();

export const Created = z.object({ id: Id });
export const Ok = z.object({ ok: z.literal(true) });
